import { createContext, ReactNode, useContext } from 'react'

export enum E_DataConfigTab {
  Hydraulic = 0,
  Fertigation = 1,
  ETReference = 2,
  PlantSoilEmitter = 3,
  GlobalConfigurations = 4,
  WaterSources = 5,
}

interface DataConfigTabContextValue {
  currentTab: E_DataConfigTab | null
}

const DataConfigTabContext = createContext<DataConfigTabContextValue>({
  currentTab: null,
})

interface DataConfigTabProviderProps {
  currentTab: E_DataConfigTab
  children: ReactNode
}

export const DataConfigTabProvider = ({
  currentTab,
  children,
}: DataConfigTabProviderProps) => {
  return (
    <DataConfigTabContext.Provider value={{ currentTab }}>
      {children}
    </DataConfigTabContext.Provider>
  )
}

export const useDataConfigTab = () => useContext(DataConfigTabContext)
